<script>
  import { MDCSwitch } from '@material/switch';
  import { onMount } from 'svelte';
  import APIClient from '../../state-charts/api-client';

  export let value = false;
  export let label;
  export let id;
  export let bold_label = false;
  export let order = null;

  let root;
  let switcher;

  const init_switcher = () => {
    // Only attach MDC for order mode. The default path owns state via
    // toggle_value + class binding — MDC on a shared #switcher-mdc id
    // caused double-toggles (especially the first switches in a list).
    if (order && root) {
      switcher = new MDCSwitch(root);
    }
  };

  const toggle_value = () => {
    value = !value;
  };

  const toggle_order = async order_uuid => {
    value = !value;
    let data = {
      hide_order_on_cv: value,
      order_uuid: order_uuid,
    };
    await APIClient.hide_order_on_cv(data);
  };

  onMount(init_switcher);
</script>

<style>
  .mdc-switch {
    margin-right: 10px;
  }

  .bold-label {
    font-weight: bold;
  }
</style>

{#if order}
  <div
    class="mdc-switch"
    class:mdc-switch--checked={!value}
    bind:this={root}
    on:click={async () => {
      await toggle_order(order);
    }}>
    <div class="mdc-switch__track" />
    <div class="mdc-switch__thumb-underlay">
      <div class="mdc-switch__thumb" />
      <input
        type="checkbox"
        {id}
        class="mdc-switch__native-control"
        role="switch"
        aria-checked="false" />
    </div>
  </div>
  <label for={id} class:bold-label={bold_label}>
    {label}
  </label>
{:else}
  <div
    class="mdc-switch"
    class:mdc-switch--checked={value}
    on:click={toggle_value}>
    <div class="mdc-switch__track" />
    <div class="mdc-switch__thumb-underlay">
      <div class="mdc-switch__thumb" />
      <input
        type="checkbox"
        {id}
        class="mdc-switch__native-control"
        role="switch"
        aria-checked={value} />
    </div>
  </div>
  <label for={id} class:bold-label={bold_label}>
    {label}
  </label>
{/if}
